/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Full_AccessInputs */



/**
* | output |
* | --- |
* | "GPT-5, Claude 4.5, Gemini 3 Pro, Mistral & many more" |
*
* @param {Pricing_Feature_Full_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_full_access = /** @type {((inputs?: Pricing_Feature_Full_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Full_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("GPT-5, Claude 4.5, Gemini 3 Pro, Mistral & viele mehr")
	return /** @type {LocalizedString} */ ("GPT-5, Claude 4.5, Gemini 3 Pro, Mistral & many more")
});